import { Provider } from "@angular/core";

import { WIDGET_HUB } from "./widget-hub.constants";
import { WidgetHubService } from "../services/widget-hub.service";


export const widgetHubProvider: Provider = {
    useClass: WidgetHubService,
    provide: WIDGET_HUB,
}